module.exports = __webpack_public_path__ + "img/lange_crub_1.1e19bb5c.jpg";